import { cn } from "~/lib/utils";
import { UserAttachment } from "./UserAttachment";

interface UserMessageProps {
  text: string;
  // IDs of artifacts the user attached to this message, each rendered as a
  // compact attachment card. Resolved by id against the conversation, so the
  // same render path serves both the live turn and a reload.
  attachmentIds?: string[];
  // Backend turn ID this message opens; exposed as `data-turn-id` so a deep
  // link can locate and scroll to the turn. Absent on turns without a known id
  // (e.g. an optimistic message before its run has started).
  turnId?: string;
  // Briefly flashes the message after a deep-link scroll lands on it.
  highlighted?: boolean;
}

export const UserMessage = ({ text, attachmentIds, turnId, highlighted }: UserMessageProps) => (
  // The deep-link highlight flashes the whole message group so it also lands on
  // attachment-only messages, which have no text bubble to carry the ring.
  <li
    data-turn-id={turnId}
    className={cn(
      "mb-2 flex max-w-[85%] flex-col items-end gap-2 self-end rounded-2xl transition-shadow duration-500",
      highlighted && "ring-2 ring-primary/60"
    )}
  >
    {attachmentIds?.map((id) => (
      <UserAttachment key={id} id={id} />
    ))}
    {text && (
      <div className="rounded-2xl rounded-br bg-muted px-4 py-3 text-sm text-foreground">
        <p className="whitespace-pre-wrap">{text}</p>
      </div>
    )}
  </li>
);
